<template>
  <div>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <div style="margin-top: 12px">
      <el-table
        :data="list"
        v-loading="listLoading"
        style="width: 100%"
        ref="table"
        class="custom-tbl"
      >
      </el-table>
    </div>
    <div>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.intPageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-form-item label="诉求类型" prop="Type">
            <el-input v-model="addForm.Type"></el-input>
          </el-form-item>
          <el-form-item label="诉求内容" prop="Content">
            <el-input v-model="addForm.Content" type="textarea" :rows="3"></el-input>
          </el-form-item>
          <el-form-item label="诉求人姓名" prop="Name">
            <el-input v-model="addForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="诉求人联系电话" prop="Tel">
            <el-input v-model="addForm.Tel"></el-input>
          </el-form-item>
          <el-form-item label="诉求状态" prop="State">
            <el-input v-model="addForm.State"></el-input>
          </el-form-item>
          <el-form-item label="诉求处理结果" prop="Result">
            <el-input v-model="addForm.Result"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { addDemand, demandList } from "@/api/demand/demand";
export default {
  components: { Toolbar },
  data() {
    return {
      page: {
        page: 1,
        intPageSize: 10,
      },
      listLoading: false,
      total: 0,
      list: [],
      buttonList: [],
      addFormVisible: false,
      addFormRules: {},
      addForm: {},
      addLoading: false,
      editFormVisible: false,
      editFormRules: {},
      editForm: {},
      editLoading: false,
      filters: {},
    };
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  methods: {
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          addDemand(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.addLoading = false;
              return;
            }
            if (res.data.success) {
              this.addLoading = false;

              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["addForm"].resetFields();

              this.addFormVisible = false;
              this.initPage();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .catch(() => {
            this.addLoading = false;
          })
        }
      });
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.intPageSize = val;
      this.getList();
    },
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
    },
    initPage() {
      this.page.page = 1;
      this.page.intPageSize = 10;
    },
    getList() {
      let params = { ...this.page };
      this.listLoading = true;
      demandList(params)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>